
export const REPORT_EMAIL_REQUEST = 'REPORT_EMAIL_REQUEST';
export const REPORT_EMAIL_FAILURE = 'REPORT_EMAIL_FAILURE';
export const REPORT_EMAIL_SUCCESS = 'REPORT_EMAIL_SUCCESS';
export const REPORT_EMAIL_ERROR = 'REPORT_EMAIL_ERROR';



// WEBPACK FOOTER //
// ./src/redux/email/types.js